import React from 'react';
import ControlsArrowsNext from './ControlsArrowsNext';
const ControlsArrowsNextS = ({ color, ...props }) => (React.createElement(ControlsArrowsNext, Object.assign({ color: color, size: 24 }, props)));
ControlsArrowsNextS.displayName = 'ControlsArrowsNextS'; // Fix for tsc
export default ControlsArrowsNextS;
//# sourceMappingURL=ControlsArrowsNextS.js.map